const awsExports = {
    aws_project_region: "us-east-1",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_X4owCw9tu",
    aws_user_pools_web_client_id: "6s7qptvlo5ichg4erhcdvg03cp",
    oauth: {
      domain: "truthset-dev1-auth-domain.auth.us-east-1.amazoncognito.com",
      scope: ["openid", "email", "profile"],
      redirectSignIn: "https://test-auth.dev1.truthset.com",
      redirectSignOut: "https://test-auth.dev1.truthset.com",
      responseType: "code",
    },
  };
  
  export default awsExports;
  